"use client";
import { useDemoController } from "@/hooks/useDemoController";
import React, { createContext, useContext } from "react";

const DemoControllerContext = createContext<ReturnType<
  typeof useDemoController
> | null>(null);

export function DemoControllerProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const demo = useDemoController();
  return (
    <DemoControllerContext.Provider value={demo}>
      {children}
    </DemoControllerContext.Provider>
  );
}

export function useDemo() {
  const ctx = useContext(DemoControllerContext);
  if (!ctx)
    throw new Error("useDemo must be used within DemoControllerProvider");
  return ctx;
}
